import { render, staticRenderFns } from "./QRCodeRestaurante.vue?vue&type=template&id=9de9d56e&scoped=true&"
import script from "./QRCodeRestaurante.vue?vue&type=script&lang=js&"
export * from "./QRCodeRestaurante.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeRestaurante.vue?vue&type=style&index=0&id=9de9d56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9d56e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCheckbox})
